// Reply.io webhook events land as LeadMessage rows distinguished by `status`.
// These four are status markers, not real messages — hide them from the Email
// thread. Real emails are 'sent' (outbound) / 'received' (inbound).
// Source of these status strings: backend/src/routes/webhooks/replyio.js.
// KEEP IN SYNC with the backend copy: backend/src/constants/replyStatusEvents.js
// (separate bundles — cannot import across the boundary).
export const STATUS_EVENT_STATUSES = ['finished', 'opted_out', 'categorized', 'bounced'];

/** True if a message row should be shown in the conversation thread. */
export function isDisplayableMessage(message) {
  if (!message) return false;
  const status = String(message.status || '').toLowerCase();
  return !STATUS_EVENT_STATUSES.includes(status);
}
